/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Form, FormInstance } from "antd";
import dayjs from "dayjs";
import equal from "fast-deep-equal";

interface UseFormDirtyCheckProps {
  invoiceForm: FormInstance;
  espForm: FormInstance;
  matchingForm: FormInstance;
  initialInvoices: any[];
  initialEsp: any[];
  initialMatching: any;
  isTypeFlight?: boolean;
}

export const useFormDirtyCheckRealtime = ({
  invoiceForm,
  espForm,
  matchingForm,
  initialInvoices,
  initialEsp,
  initialMatching,
  isTypeFlight = false,
}: UseFormDirtyCheckProps) => {
  const [invoiceDirty, setInvoiceDirty] = useState(false);
  const [espDirty, setEspDirty] = useState(false);
  const [matchingDirty, setMatchingDirty] = useState(false);

  // helper: format date for comparison
  const formatInvoices = (invoices: any[]) =>
    invoices.map((invoiceDetail: any) => ({
      invoiceNumber: invoiceDetail.invoiceNumber,
      currency: invoiceDetail.currency,
      totalAmount: invoiceDetail.totalAmount,
      ...(isTypeFlight
        ? { transactionDate: invoiceDetail.transactionDate ? dayjs(invoiceDetail.transactionDate) : null }
        : {
            invoiceDate: invoiceDetail.invoiceDate ? dayjs(invoiceDetail.invoiceDate) : null,
            invoiceEmail: {
              receivedAt: invoiceDetail?.invoiceEmail?.receivedAt
                ? dayjs(invoiceDetail?.invoiceEmail?.receivedAt)
                : null,
            },
          }),
      supplierInvoiceRecords: invoiceDetail.supplierInvoiceRecords.map((sir: any) => ({
        bookingNo: sir.bookingNo,
        leadPax: sir.leadPax,
        amount: sir.amount,
        isActive: sir.isActive,
        reason: sir.reason,
        note: sir.note,
        ...(!!sir?.invoiceMatchId && {
          bookingNo: sir?.bookingNo ? sir?.bookingNo + `${sir?.bookingNo.includes("-CR") ? "" : "-CR"}` : "CR",
        }),
      })),
    }));

  const formatEsp = (espList: any[]) =>
    espList.map((esp) => ({
      ...esp,
      dueDate: esp.dueDate ? dayjs(esp.dueDate).format("YYYY-MM-DD") : null,
    }));

  // Watch invoices
  const currentInvoices = Form.useWatch("invoices", invoiceForm) || [];
  useEffect(() => {
    setInvoiceDirty(!equal(formatInvoices(currentInvoices), formatInvoices(initialInvoices)));
  }, [currentInvoices, initialInvoices, isTypeFlight]);

  // Watch esp
  const currentEsp = Form.useWatch("expectedSupplierPayments", espForm) || [];
  useEffect(() => {
    setEspDirty(!equal(formatEsp(currentEsp), formatEsp(initialEsp)));
  }, [currentEsp, initialEsp]);

  // Watch matching form
  const currentMatching = Form.useWatch([], matchingForm) || {};
  useEffect(() => {
    if (!currentMatching?.comment) {
      delete currentMatching?.comment;
    }
    setMatchingDirty(!equal(currentMatching, initialMatching));
  }, [currentMatching, initialMatching]);

  const anyDirty = invoiceDirty || espDirty || matchingDirty;

  return { invoiceDirty, espDirty, matchingDirty, anyDirty };
};
